export enum SubmitMessage {
    Success = 'Information was sent successfully, thank you for contacting',
    Error = "Sorry, information wasn't sent because of technical problem",
}
